export const categories = [
  { id: "all", name: "全部", slug: "all", icon: "ri-global-line", color: "primary" },
  { id: "yulequan", name: "娱乐圈", slug: "yulequan", icon: "ri-movie-2-line", color: "accent" },
  { id: "wanghongquan", name: "网红圈", slug: "wanghongquan", icon: "ri-live-line", color: "secondary" },
  { id: "shehuiredian", name: "社会热点", slug: "shehuiredian", icon: "ri-fire-line", color: "primary" },
  { id: "mingxingdongtai", name: "明星动态", slug: "mingxingdongtai", icon: "ri-star-line", color: "accent" },
  { id: "qingganbagua", name: "情感八卦", slug: "qingganbagua", icon: "ri-heart-2-line", color: "secondary" },
  { id: "zongyijiemu", name: "综艺节目", slug: "zongyijiemu", icon: "ri-tv-2-line", color: "primary" },
  { id: "dianshiju", name: "电视剧集", slug: "dianshiju", icon: "ri-clapperboard-line", color: "accent" },
];

export const articles = [
  {
    id: 1,
    title: "某顶流男星深夜密会神秘女子，酒店同框画面曝光引热议",
    slug: "dingliu-nanxing-shenye-mihui",
    excerpt: "近日有媒体拍到某当红顶流男星深夜与一名神秘女子同框出入某五星级酒店，两人举止亲密，引发网友热议和猜测。",
    content: `<p>近日，有八卦媒体拍到一组令人震惊的画面。某当红顶流男星深夜现身北京某五星级酒店，身边还有一位身材高挑的神秘女子。两人一前一后进入酒店大厅，虽然都戴着口罩和帽子，但依然被眼尖的狗仔认出。</p>
<p>据目击者透露，该男星与神秘女子在酒店大堂表现得十分谨慎，刻意保持距离。但进入电梯后，两人便摘下了口罩，开始有说有笑，举止颇为亲密。</p>
<p>消息一出，立刻在微博上引发轩然大波。粉丝纷纷留言表示"不相信""等官方回应"，但也有不少吃瓜群众已经开始深扒神秘女子的身份。</p>
<p>截至目前，该男星工作室尚未对此事作出任何回应。我们将持续关注事件后续发展。</p>`,
    category: "yulequan",
    author: "吃瓜小分队",
    date: "2026-08-04",
    time: "14:32",
    views: 128567,
    image: "https://readdy.ai/api/search-image?query=A%20dimly%20lit%20luxury%20hotel%20lobby%20at%20night%20with%20two%20silhouetted%20figures%20walking%20apart%20but%20glancing%20at%20each%20other%2C%20paparazzi%20style%20photography%2C%20moody%20atmosphere%20with%20warm%20golden%20lighting%2C%20cinematic%20composition%2C%20mysterious%20and%20dramatic%20mood&width=800&height=450&seq=article-01&orientation=landscape",
    tags: ["顶流", "男星", "恋情", "酒店"],
    featured: true,
    hot: true,
  },
  {
    id: 2,
    title: "某知名女星被曝与富商男友分手，深夜发文暗示情变",
    slug: "zhiming-nvxing-fenshou-fushang",
    excerpt: "知名女星深夜在社交平台发布一段意味深长的文字，疑似暗示与相恋两年的富商男友已经分道扬镳，粉丝纷纷留言安慰。",
    content: `<p>8月3日深夜，知名女星林某某在个人社交账号上发布了一段文字："有些路，走着走着就散了；有些人，爱着爱着就淡了。" 这段意味深长的话语立刻引发了粉丝和网友的广泛猜测。</p>
<p>据悉，林某某与某地产富商之子已交往两年多，此前两人多次被拍到一起出游、共进晚餐，感情看起来十分稳定。但最近三个月，两人再也没有被拍到同框的画面。</p>
<p>有知情人士透露，两人分手的原因可能与家庭背景差异有关。"男方的家庭比较传统，对于娱乐圈的女艺人始终存在偏见，这给两人的关系带来了很大的压力。"</p>
<p>截至目前，林某某和男方均未对分手传闻作出正式回应。但粉丝们已经在评论区刷屏留言，表达对偶像的支持和关心。</p>`,
    category: "yulequan",
    author: "八卦早知道",
    date: "2026-08-04",
    time: "11:15",
    views: 98532,
    image: "https://readdy.ai/api/search-image?query=A%20beautiful%20woman%20silhouette%20looking%20out%20a%20rainy%20window%20at%20night%20with%20city%20lights%20reflected%2C%20melancholic%20mood%2C%20soft%20warm%20interior%20lighting%2C%20cinematic%20photography%20style%2C%20emotional%20and%20atmospheric&width=800&height=450&seq=article-02&orientation=landscape",
    tags: ["女星", "分手", "富商", "情变"],
    featured: true,
    hot: true,
  },
  {
    id: 3,
    title: "某网红直播带货翻车，产品质量遭质疑，粉丝数一夜暴跌",
    slug: "wanghong-zhibo-fanche",
    excerpt: "坐拥千万粉丝的头部网红在直播带货中推荐的产品被曝质量问题，大量消费者投诉后，该网红粉丝数一夜之间暴跌数十万。",
    content: `<p>近日，坐拥千万粉丝的知名网红"小美酱"在直播带货过程中翻车了。其推荐的一款护肤品被大量消费者投诉使用后出现过敏、红肿等不良反应。</p>
<p>事件发酵后，越来越多的消费者站出来曝光，称该产品不仅效果不佳，而且疑似是"三无产品"。更有细心的网友发现，该产品在多个电商平台上的评价存在大量疑似刷单的痕迹。</p>
<p>面对汹涌的舆论，小美酱在最新直播中含泪道歉，表示将全额退款并承担所有消费者的医疗费用。但这一道歉并未平息众怒，其粉丝数量在短短24小时内暴跌超过50万。</p>
<p>业内人士分析认为，网红带货行业缺乏有效监管是导致此类事件频发的根本原因。消费者在购买网红推荐产品时应保持理性。</p>`,
    category: "wanghongquan",
    author: "吃瓜小分队",
    date: "2026-08-03",
    time: "20:45",
    views: 76543,
    image: "https://readdy.ai/api/search-image?query=A%20streamer%20sitting%20at%20a%20desk%20with%20ring%20light%20and%20products%20scattered%20around%2C%20looking%20distressed%20and%20apologetic%2C%20warm%20studio%20lighting%2C%20modern%20apartment%20background%2C%20realistic%20streaming%20setup%20photography&width=800&height=450&seq=article-03&orientation=landscape",
    tags: ["网红", "直播带货", "翻车", "产品质量"],
    featured: false,
    hot: true,
  },
  {
    id: 4,
    title: "某综艺节目录制现场爆发激烈冲突，两位嘉宾当场翻脸",
    slug: "zongyi-jie mu-chongtu",
    excerpt: "热门综艺节目录制现场突发状况，两位常驻嘉宾因游戏环节发生争执，情绪激动之下当场翻脸，节目组紧急暂停录制。",
    content: `<p>据现场观众爆料，某热门综艺节目在最新一期录制过程中出现了意外状况。在某个游戏环节中，两位常驻嘉宾因为规则理解不同产生了分歧，随后争论升级为激烈的口角冲突。</p>
<p>"当时现场气氛特别紧张，两个人都站起来互相指责，其中一个还摔了手里的道具。"一位现场观众回忆道，"节目组的工作人员赶紧上去拉架，导演也喊了暂停。"</p>
<p>据悉，这两位嘉宾此前就曾在社交媒体上有过一些暗戳戳的互动，被网友解读为"塑料兄弟情"。这次冲突似乎印证了两人关系确实不睦的猜测。</p>
<p>节目组随后发表声明表示，录制过程中的小摩擦属于正常现象，两位嘉宾已经和解，节目将正常播出。但网友对此说法并不买账。</p>`,
    category: "zongyijiemu",
    author: "八卦早知道",
    date: "2026-08-03",
    time: "16:20",
    views: 134256,
    image: "https://readdy.ai/api/search-image?query=A%20television%20studio%20set%20with%20bright%20stage%20lighting%20and%20cameras%2C%20two%20people%20standing%20facing%20each%20other%20with%20tense%20body%20language%2C%20crew%20members%20in%20background%20looking%20concerned%2C%20dramatic%20atmosphere%2C%20reality%20show%20production%20style&width=800&height=450&seq=article-04&orientation=landscape",
    tags: ["综艺", "冲突", "嘉宾", "录制事故"],
    featured: true,
    hot: true,
  },
  {
    id: 5,
    title: "某明星夫妻被传婚变，双方工作室集体沉默引猜测",
    slug: "mingxing-fuqi-hunbian",
    excerpt: "娱乐圈模范夫妻被传出婚变消息，双方工作室对此保持沉默已超过48小时，反常态度让婚变传闻愈演愈烈。",
    content: `<p>娱乐圈又一对"模范夫妻"被传出婚变消息。据多方消息源透露，知名演员陈某与妻子李某已经分居数月，两人最近一次公开同框还是在三个月前的一场慈善活动上。</p>
<p>更加耐人寻味的是，面对铺天盖地的婚变传闻，双方工作室均选择了沉默。通常明星面对不实传闻会迅速辟谣，但这次48小时过去了，双方没有任何回应。这种反常的态度让网友们更加确信婚变传闻属实。</p>
<p>有圈内人士透露，两人感情出现问题的主要原因可能是工作聚少离多。"一个常年在剧组拍戏，一个全国各地跑综艺，一年到头在一起的时间屈指可数。"</p>
<p>目前，两人的社交媒体上已经找不到任何与对方相关的内容，这一细节也被网友视为婚变的"实锤"。</p>`,
    category: "mingxingdongtai",
    author: "吃瓜小分队",
    date: "2026-08-02",
    time: "09:30",
    views: 89210,
    image: "https://readdy.ai/api/search-image?query=A%20luxurious%20living%20room%20with%20two%20empty%20chairs%20facing%20away%20from%20each%20other%2C%20soft%20evening%20light%20streaming%20through%20windows%2C%20melancholic%20atmosphere%2C%20cinematic%20composition%2C%20emotional%20distance%20theme&width=800&height=450&seq=article-05&orientation=landscape",
    tags: ["明星夫妻", "婚变", "沉默", "分居"],
    featured: false,
    hot: true,
  },
  {
    id: 6,
    title: "某知名主持人被拍到与年轻女子同游三亚，疑似新恋情曝光",
    slug: "zhuchi ren-xinlianqing",
    excerpt: "知名主持人被狗仔拍到与一名年轻女子在三亚海边度假，两人互动亲密，疑似新恋情浮出水面。",
    content: `<p>近日，知名主持人王某被狗仔拍到与一名年轻貌美的女子在三亚某度假酒店共度假期。照片中两人穿着清凉，在海边漫步时有说有笑，王某还不时搂着女方的肩膀，举止十分亲密。</p>
<p>此前王某曾公开表示自己单身，这次被拍到的画面似乎说明他的感情状态已经发生了变化。网友们迅速开始扒这位神秘女子的身份，有人猜测是某模特公司的签约模特，也有人说是圈外人。</p>
<p>有趣的是，王某的粉丝对于偶像的新恋情反应相当积极，大部分留言都是祝福和期待的。"王老师也到了该成家的年纪了，支持！"一位粉丝在超话中写道。</p>
<p>截至目前，王某本人并未对此事作出回应。但其经纪人在接受媒体采访时表示"艺人的私生活不便过问"，这一模糊态度被解读为默认。</p>`,
    category: "mingxingdongtai",
    author: "八卦早知道",
    date: "2026-08-02",
    time: "15:10",
    views: 67543,
    image: "https://readdy.ai/api/search-image?query=A%20tropical%20beach%20in%20Sanya%20with%20palm%20trees%20and%20turquoise%20water%2C%20two%20people%20walking%20along%20the%20shoreline%20from%20a%20distance%2C%20golden%20sunset%20light%2C%20romantic%20atmosphere%2C%20travel%20photography%20style&width=800&height=450&seq=article-06&orientation=landscape",
    tags: ["主持人", "恋情", "三亚", "度假"],
    featured: false,
    hot: false,
  },
  {
    id: 7,
    title: "电视剧《某某传》拍摄现场发生意外，女主演受伤送医",
    slug: "dianshiju-paishe-yiwai",
    excerpt: "大型古装剧拍摄现场突发意外，女主演在一场打戏中不慎摔倒受伤，被紧急送往医院治疗，剧组宣布暂停拍摄。",
    content: `<p>今日上午，正在横店影视城紧张拍摄的大型古装剧《某某传》剧组发生意外。女主演在一场激烈的打戏中不慎从威亚上摔落，导致脚踝受伤，被紧急送往当地医院接受治疗。</p>
<p>据现场工作人员透露，当时正在拍摄一场女主角与反派激烈交锋的重头戏。由于威亚设备出现小故障，女演员在落地时没能控制好身体平衡，导致了这次意外。</p>
<p>剧组随后发布公告，确认女主演脚踝扭伤，并无大碍，但需要休养一到两周。剧组已决定暂停拍摄，等待女主演康复后再继续。</p>
<p>该剧是今年最受期待的古装剧之一，投资巨大，演员阵容豪华。这次意外是否会影响剧集的播出时间，目前尚不明确。</p>`,
    category: "dianshiju",
    author: "吃瓜小分队",
    date: "2026-08-01",
    time: "18:55",
    views: 112345,
    image: "https://readdy.ai/api/search-image?query=A%20film%20set%20of%20a%20historical%20Chinese%20drama%20with%20ancient%20costumes%20and%20props%2C%20crew%20members%20gathered%20around%20with%20concerned%20expressions%2C%20professional%20film%20equipment%20in%20background%2C%20dramatic%20lighting%2C%20behind%20the%20scenes%20atmosphere&width=800&height=450&seq=article-07&orientation=landscape",
    tags: ["电视剧", "拍摄意外", "受伤", "古装剧"],
    featured: true,
    hot: true,
  },
  {
    id: 8,
    title: "某男星被前女友爆料恋爱期间出轨多人，聊天记录曝光",
    slug: "nanxing-chugui-baoliao",
    excerpt: "一位自称是某男星前女友的女子在社交平台发布长篇爆料，指控该男星在恋爱期间多次出轨，并晒出多张聊天记录截图。",
    content: `<p>今日凌晨，一条爆炸性的爆料在社交平台引发轰动。一位自称是某当红男星前女友的女子发布长文，详细描述了两人的恋爱经历，并指控男方在恋爱期间多次出轨。</p>
<p>该女子在文中写道："我以为我是他的唯一，没想到我只是他鱼塘里的一条鱼。"她还晒出了多张聊天记录截图，内容涉及该男星与多名女性的暧昧对话。</p>
<p>爆料发布后，迅速登上热搜榜首。该男星的粉丝团第一时间发声，质疑聊天记录的真实性，认为截图可能是伪造的。但爆料者随后又放出了更多证据，包括两人的合照和视频通话截图。</p>
<p>目前该男星尚未回应。但据接近其工作室的人士透露，团队正在紧急商讨应对方案。无论爆料是否属实，这一事件对该男星的形象已经造成了不小的影响。</p>`,
    category: "yulequan",
    author: "八卦早知道",
    date: "2026-08-01",
    time: "08:00",
    views: 156789,
    image: "https://readdy.ai/api/search-image?query=A%20smartphone%20screen%20displaying%20chat%20messages%20on%20a%20dark%20desk%20with%20dramatic%20lighting%2C%20mysterious%20atmosphere%2C%20social%20media%20scandal%20theme%2C%20digital%20privacy%20concept%2C%20cinematic%20photography&width=800&height=450&seq=article-08&orientation=landscape",
    tags: ["出轨", "爆料", "聊天记录", "前女友"],
    featured: true,
    hot: true,
  },
  {
    id: 9,
    title: "某知名网红被举报偷税漏税，税务机关已介入调查",
    slug: "wanghong-toushui-diaocha",
    excerpt: "继多位明星之后，又有知名网红因涉嫌偷税漏税被举报。据悉税务机关已正式立案调查，该网红或将面临巨额罚款。",
    content: `<p>近日，一则关于网红偷税漏税的消息在圈内流传。据悉，某拥有超过两千万粉丝的头部网红被人实名举报涉嫌偷税漏税，金额高达数千万元。</p>
<p>举报人称，该网红通过多个空壳公司和虚假合同转移收入，在近三年内逃避了巨额个人所得税。税务机关在接到举报后已经正式立案，目前正在调查取证阶段。</p>
<p>近年来，税务部门对高收入群体的税收监管越来越严格。此前已有数位明星因为税务问题被查处，罚款金额从数百万到上亿不等。</p>
<p>业内人士表示，随着直播带货行业的高速发展，网红的收入已经达到了惊人的水平，但税务合规意识普遍不强。此次调查可能会在整个网红行业引发连锁反应。</p>`,
    category: "wanghongquan",
    author: "吃瓜小分队",
    date: "2026-07-31",
    time: "10:20",
    views: 98765,
    image: "https://readdy.ai/api/search-image?query=A%20serious%20office%20scene%20with%20documents%20and%20calculators%20on%20a%20wooden%20desk%2C%20a%20person%20in%20shadow%20looking%20at%20financial%20papers%2C%20tense%20atmosphere%2C%20professional%20photography%2C%20concept%20of%20tax%20investigation&width=800&height=450&seq=article-09&orientation=landscape",
    tags: ["网红", "偷税漏税", "调查", "罚款"],
    featured: false,
    hot: true,
  },
  {
    id: 10,
    title: "某选秀节目人气选手被扒出大量黑历史，人设面临崩塌",
    slug: "xuanxiu-xuanshou-heilishi",
    excerpt: "选秀节目人气选手被网友扒出大量过往不当言行，包括校园霸凌、整容等争议，精心打造的阳光人设面临崩塌危机。",
    content: `<p>今年的热门选秀节目中，一位人气爆棚的选手在被观众捧上神坛的同时，黑历史也如影随形地被扒了出来。</p>
<p>有网友整理了该选手大量过往的社交动态，其中包括一些涉及校园霸凌的暗示性言论、对同行的不尊重评价，以及一些性别歧视倾向的发言。这些内容与他在节目中塑造的阳光暖男人设形成了鲜明对比。</p>
<p>除此之外，关于他整容的传闻也被翻了出来。有整形医生对比了他早期和现在的照片后表示，"从专业角度看，至少做了双眼皮、鼻综合和下颌角三项手术。"</p>
<p>面对铺天盖地的质疑，该选手在粉丝见面会上哽咽回应："年轻的时候不懂事，说过一些不该说的话，我向大家道歉。"但这样的回应并未让所有网友满意。</p>`,
    category: "zongyijiemu",
    author: "八卦早知道",
    date: "2026-07-31",
    time: "14:50",
    views: 143256,
    image: "https://readdy.ai/api/search-image?query=A%20young%20performer%20on%20a%20talent%20show%20stage%20with%20spotlight%2C%20looking%20emotional%20and%20vulnerable%2C%20dark%20audience%20in%20background%2C%20dramatic%20stage%20lighting%2C%20reality%20competition%20show%20aesthetic&width=800&height=450&seq=article-10&orientation=landscape",
    tags: ["选秀", "黑历史", "人设", "整容"],
    featured: false,
    hot: false,
  },
  {
    id: 11,
    title: "某女星产后复出状态惊艳，网友直呼：这哪像生过孩子",
    slug: "nvxing-chanhou-fuchu",
    excerpt: "知名女星产后首次公开亮相，身材恢复堪称完美，状态极佳惊艳全场。网友纷纷感叹完全看不出是刚生完孩子的人。",
    content: `<p>昨晚某时尚活动现场，产后三个月的知名女星张某首次公开亮相，立刻成为全场焦点。只见她身穿一袭黑色修身长裙，身材凹凸有致，完全看不出刚刚经历了生产。</p>
<p>面对媒体镜头，张某笑容灿烂，状态看起来非常好。当被问及产后恢复的秘诀时，她表示主要是坚持科学饮食和适度运动。"没有捷径，就是管住嘴迈开腿，"她笑着说，"还有就是月嫂帮忙带娃，我才能有时间做产后修复。"</p>
<p>张某的这次亮相在网络上引发热议，相关话题迅速登上热搜。网友纷纷留言："这状态也太好了吧！""生完孩子更美了！""果然明星和普通人的产后恢复不是一个概念。"</p>
<p>据悉，张某接下来将逐步恢复工作，已经有多部新剧和综艺节目向她抛出了橄榄枝。</p>`,
    category: "mingxingdongtai",
    author: "吃瓜小分队",
    date: "2026-07-30",
    time: "19:30",
    views: 87654,
    image: "https://readdy.ai/api/search-image?query=An%20elegant%20woman%20in%20a%20black%20evening%20dress%20at%20a%20fashion%20event%20red%20carpet%2C%20posing%20confidently%20under%20camera%20flashes%2C%20luxurious%20venue%20background%2C%20glamorous%20celebrity%20photography%2C%20sophisticated%20atmosphere&width=800&height=450&seq=article-11&orientation=landscape",
    tags: ["女星", "产后复出", "状态", "身材"],
    featured: false,
    hot: false,
  },
  {
    id: 12,
    title: "某艺人被传患上抑郁症，工作室发声明呼吁停止网络暴力",
    slug: "yiren-yiyuzheng-shengming",
    excerpt: "近日某艺人被传出患上抑郁症的消息，工作室随后发表声明确认其正在接受心理治疗，并呼吁网友停止网络暴力。",
    content: `<p>近日有媒体爆料某知名艺人因长期遭受网络暴力患上抑郁症，目前正在接受专业的心理治疗。消息传出后引发了广泛关注和讨论。</p>
<p>该艺人工作室随后发表正式声明，确认了艺人正在接受心理治疗的事实。"感谢大家的关心，她确实因为长期承受巨大的舆论压力，出现了情绪方面的问题。目前正在专业医生的指导下积极治疗，情况正在好转。"</p>
<p>声明中还特别提到，希望网友能够停止对艺人的恶意攻击和人身侮辱。"网络不是法外之地，每一句恶意的评论都可能成为压垮一个人的最后一根稻草。"</p>
<p>此声明发布后，大量网友表达了支持和祝福。但也有人认为，艺人享受着高额收入，承受舆论压力是职业的一部分。</p>`,
    category: "yulequan",
    author: "八卦早知道",
    date: "2026-07-30",
    time: "11:00",
    views: 76543,
    image: "https://readdy.ai/api/search-image?query=A%20person%20sitting%20alone%20by%20a%20window%20in%20a%20dimly%20lit%20room%2C%20sunlight%20barely%20breaking%20through%20curtains%2C%20melancholic%20and%20contemplative%20mood%2C%20emotional%20portrait%20photography%2C%20warm%20but%20somber%20atmosphere&width=800&height=450&seq=article-12&orientation=landscape",
    tags: ["抑郁症", "网络暴力", "心理治疗", "声明"],
    featured: false,
    hot: false,
  },
  {
    id: 13,
    title: "网红城市街头偶遇明星情侣，甜蜜逛街被路人拍下",
    slug: "mingxing-jietou-ouyu",
    excerpt: "有网友在某网红城市的商业街偶遇一对明星情侣甜蜜逛街，两人穿着休闲大方自然，路人纷纷拍照围观。",
    content: `<p>昨日，有网友在某热门旅游城市的商业街上偶遇了一对明星情侣。两人穿着休闲随意，没有戴口罩和墨镜遮掩，大方地十指紧扣逛街，看起来十分甜蜜。</p>
<p>据目击网友描述，两人先是在一家咖啡馆坐了一会儿，然后沿街逛了几家特色小店。期间男方一直很贴心地帮女方拎包，遇到认出他们的路人也会友好地打招呼。</p>
<p>"完全没有明星架子，就像普通情侣一样，"一位偶遇的网友说，"我从他们身边走过才认出来的，两个人都笑得很开心，感觉感情特别好。"</p>
<p>这组偶遇照片在网上传开后，获得了大量点赞。不少网友表示："这才是谈恋爱该有的样子""希望他们一直这么甜下去""路人视角比精修图好看一百倍"。</p>`,
    category: "mingxingdongtai",
    author: "吃瓜小分队",
    date: "2026-07-29",
    time: "16:45",
    views: 65432,
    image: "https://readdy.ai/api/search-image?query=A%20vibrant%20shopping%20street%20in%20a%20trendy%20Chinese%20city%20with%20colorful%20storefronts%2C%20a%20couple%20walking%20hand%20in%20hand%20in%20casual%20clothing%2C%20warm%20afternoon%20sunlight%2C%20candid%20street%20photography%20style%2C%20happy%20and%20relaxed%20atmosphere&width=800&height=450&seq=article-13&orientation=landscape",
    tags: ["明星情侣", "偶遇", "逛街", "甜蜜"],
    featured: false,
    hot: false,
  },
  {
    id: 14,
    title: "社会热点：某高校教授被举报学术不端，校方已成立调查组",
    slug: "gaoxiao-jiaoshou-xueshubuduan",
    excerpt: "某知名高校教授被多人实名举报存在学术不端行为，涉及论文抄袭、数据造假等问题，校方表示已成立专门调查组。",
    content: `<p>近日，某知名高校的一位资深教授被多名同行和学生在网上实名举报，指控其存在严重的学术不端行为。举报内容涉及多篇已发表论文的抄袭、实验数据造假以及侵占他人研究成果等问题。</p>
<p>举报材料长达数十页，详细列举了被举报教授的多篇论文与其他学者已发表成果的雷同之处，并用红色标注了高度相似的段落。举报人还提供了原始实验数据与被篡改后数据的对比。</p>
<p>事件曝光后，校方迅速作出回应，表示已成立由校内外专家组成的独立调查组，将对此事进行全面调查。"学术诚信是高校的底线，对任何学术不端行为我们持零容忍态度。"</p>
<p>这起事件在学术界和网络上引发了激烈讨论。有人认为学术不端是教育界的顽疾，需要更严厉的惩罚机制；也有人呼吁在调查结果出来前不要妄下定论。</p>`,
    category: "shehuiredian",
    author: "八卦早知道",
    date: "2026-07-29",
    time: "09:00",
    views: 134567,
    image: "https://readdy.ai/api/search-image?query=A%20university%20campus%20building%20with%20solemn%20atmosphere%2C%20stacks%20of%20academic%20papers%20and%20books%20on%20a%20desk%20in%20foreground%2C%20serious%20academic%20setting%2C%20soft%20natural%20light%20through%20windows%2C%20documentary%20photography%20style&width=800&height=450&seq=article-14&orientation=landscape",
    tags: ["学术不端", "高校", "教授", "举报"],
    featured: false,
    hot: true,
  },
  {
    id: 15,
    title: "大S与汪小菲离婚后首次公开同框，为女儿庆生场面温馨",
    slug: "das-wangxiaofei-tongkuang",
    excerpt: "大S与汪小菲离婚后首次被拍到同框，两人为了女儿的生日放下过往恩怨，共同出席派对，场面温馨感人。",
    content: `<p>近日，大S与汪小菲被拍到共同出席女儿的生日派对，这是两人离婚后首次公开同框。尽管婚姻已经结束，但为了女儿他们选择了和平相处。</p>
<p>据现场宾客透露，派对在一个私密的场所举行，只邀请了至亲好友。大S负责策划了整个派对的主题和装饰，而汪小菲则负责安排了餐饮。两人虽然互动不多，但都穿着得体，面带微笑，给了女儿一个快乐的生日。</p>
<p>"看到他们能够为了孩子放下过去的恩怨，真的很不容易，"一位参加派对的亲友表示，"小朋友特别开心，爸爸妈妈都在身边，这才是最重要的。"</p>
<p>这组照片在网上曝光后，获得了大量正面评价。网友纷纷表示："为了孩子能做到这样很了不起""成熟的父母""希望他们各自都能幸福"。</p>`,
    category: "shehuiredian",
    author: "吃瓜小分队",
    date: "2026-07-28",
    time: "20:00",
    views: 234567,
    image: "https://readdy.ai/api/search-image?query=A%20warm%20birthday%20party%20setting%20with%20colorful%20balloons%20and%20decorations%2C%20a%20family%20gathered%20around%20a%20cake%2C%20soft%20golden%20lighting%2C%20heartwarming%20atmosphere%2C%20candid%20family%20photography%2C%20celebration%20mood&width=800&height=450&seq=article-15&orientation=landscape",
    tags: ["大S", "汪小菲", "同框", "女儿生日"],
    featured: true,
    hot: true,
  },
  {
    id: 16,
    title: "某品牌代言人突然被换，知情人透露与近期负面新闻有关",
    slug: "pinpai-daiyanren-beihuan",
    excerpt: "某国际品牌在合约未到期的情况下突然更换代言人，知情人士透露该决定与代言人近期的负面新闻密切相关。",
    content: `<p>日前，某国际知名品牌在社交平台上官宣了新的品牌代言人，引发关注。令人意外的是，原代言人的合约尚未到期，这次更换属于提前解约。</p>
<p>据知情人士透露，品牌方之所以做出这一决定，与原代言人近期的负面新闻密切相关。"品牌最在乎的就是形象，一旦代言人出现可能损害品牌声誉的负面事件，品牌方通常会迅速切割。"</p>
<p>据悉，原代言人近几个月来确实风波不断，先是被曝出与某争议人物的亲密关系，后又陷入了一场商业纠纷。虽然这些事件尚未有定论，但显然已经对品牌的决策产生了影响。</p>
<p>品牌方在官方声明中仅表示"基于战略调整需要"，并未提及任何与原代言人相关的原因。但网友们普遍认为，这不过是商业话术罢了。</p>`,
    category: "yulequan",
    author: "八卦早知道",
    date: "2026-07-28",
    time: "13:20",
    views: 87654,
    image: "https://readdy.ai/api/search-image?query=A%20luxury%20brand%20billboard%20being%20changed%20on%20a%20busy%20city%20street%2C%20workers%20on%20scaffolding%2C%20urban%20commercial%20setting%2C%20overcast%20day%2C%20corporate%20photography%20style&width=800&height=450&seq=article-16&orientation=landscape",
    tags: ["品牌代言", "更换", "负面新闻", "解约"],
    featured: false,
    hot: false,
  },
  {
    id: 17,
    title: "某女星自曝曾被圈内前辈骚扰，勇敢发声获全网力挺",
    slug: "nvxing-beisaorao-fasheng",
    excerpt: "某女星在访谈中首次自曝刚入行时曾遭到圈内前辈的骚扰，她选择勇敢发声，获得全网一边倒的支持与点赞。",
    content: `<p>在一次深度访谈中，某女星首次公开谈及了自己刚入行时的一段不堪经历。她透露曾被一位圈内德高望重的前辈以"指导演技"为由进行骚扰。</p>
<p>"那时候我才二十出头，什么都不懂，以为前辈是真的想帮我，"她在访谈中哽咽着说，"后来才知道他对我有别的企图。我很害怕，但我不敢说，怕得罪人，怕被封杀。"</p>
<p>她表示最终选择站出来发声是因为看到了越来越多的受害者勇敢说出自己的遭遇。"沉默不会让事情变好，只有说出来，才能让那些心怀不轨的人有所忌惮。"</p>
<p>这段访谈播出后迅速在全网传播，获得了压倒性的支持。众多明星同行也纷纷转发力挺，称赞她的勇气。相关话题在微博上获得了超过5亿的阅读量。</p>`,
    category: "yulequan",
    author: "吃瓜小分队",
    date: "2026-07-27",
    time: "17:30",
    views: 198765,
    image: "https://readdy.ai/api/search-image?query=A%20woman%20in%20a%20television%20interview%20setting%20speaking%20emotionally%20into%20a%20microphone%2C%20soft%20studio%20lighting%2C%20serious%20and%20courageous%20expression%2C%20documentary%20style%20photography%2C%20empowerment%20theme&width=800&height=450&seq=article-17&orientation=landscape",
    tags: ["女星", "骚扰", "勇敢发声", "支持"],
    featured: true,
    hot: true,
  },
  {
    id: 18,
    title: "某恋综节目牵手情侣被曝已同居，甜蜜日常曝光",
    slug: "lianzong-qianshou-tongju",
    excerpt: "恋爱综艺节目中牵手成功的网红情侣被曝已经同居，两人在社交媒体上频频晒出同居日常，甜蜜互动羡煞旁人。",
    content: `<p>去年的热门恋爱综艺节目中牵手成功的一对网红情侣近日被曝已经正式同居。细心的网友从两人最近发布的视频和照片中发现了越来越多的"同居证据"。</p>
<p>从同款的家居服、一样的窗帘背景，到不经意间出现在镜头里的对方物品，再到两人发布的做饭视频中一模一样的厨房布置——种种细节都指向两人已经住在了一起。</p>
<p>对此，两人在最新的直播中大方承认了同居的事实。"我们觉得感情到了这个阶段，住在一起是很自然的事情，"女方在直播中笑着说，"每天一起做饭、一起遛狗、一起追剧，就是我最想要的生活。"</p>
<p>粉丝们对于两人的进展感到十分开心，评论区被祝福刷屏。有网友调侃道："恋综终于出了一对靠谱的，希望你们能走到最后！"</p>`,
    category: "qingganbagua",
    author: "八卦早知道",
    date: "2026-07-27",
    time: "10:00",
    views: 76543,
    image: "https://readdy.ai/api/search-image?query=A%20cozy%20modern%20apartment%20interior%20with%20warm%20lighting%2C%20a%20couple%20cooking%20together%20in%20an%20open%20kitchen%2C%20laughing%20and%20enjoying%20each%20others%20company%2C%20lifestyle%20photography%2C%20domestic%20bliss%20atmosphere&width=800&height=450&seq=article-18&orientation=landscape",
    tags: ["恋综", "同居", "情侣", "甜蜜"],
    featured: false,
    hot: false,
  },
  {
    id: 19,
    title: "某老牌歌手时隔十年再开演唱会，门票开售秒空创纪录",
    slug: "laopai-geshou-yanchanghui",
    excerpt: "某老牌实力歌手宣布时隔十年再次举办巡回演唱会，门票开售后在30秒内全部售罄，创造了该平台今年最快售罄纪录。",
    content: `<p>昨天上午十点，某老牌实力派歌手的巡回演唱会门票正式开售。令人震惊的是，所有场次的门票在开售后短短30秒内便被抢购一空，创造了今年演唱会门票销售的最快纪录。</p>
<p>这位歌手上一次举办个人演唱会还是在十年前。此次复出演唱会的消息一经公布，便引发了巨大关注。许多老歌迷表示，等了十年终于等到了。</p>
<p>"我从初中就开始听他的歌，现在已经工作五年了，"一位成功抢到票的粉丝激动地表示，"能抢到票简直像中了彩票一样开心。"</p>
<p>主办方表示，考虑到巨大的市场需求，正在与歌手团队协商增加场次的可能性。但歌手本人此前曾表示，考虑到体力因素，此次巡演不会超过十场。</p>`,
    category: "yulequan",
    author: "吃瓜小分队",
    date: "2026-07-26",
    time: "12:00",
    views: 112345,
    image: "https://readdy.ai/api/search-image?query=A%20massive%20concert%20stadium%20filled%20with%20enthusiastic%20crowd%20and%20colorful%20stage%20lights%2C%20a%20performer%20silhouette%20on%20stage%2C%20grand%20scale%20event%20photography%2C%20electric%20atmosphere%2C%20music%20concert%20aesthetic&width=800&height=450&seq=article-19&orientation=landscape",
    tags: ["歌手", "演唱会", "秒空", "复出"],
    featured: false,
    hot: true,
  },
  {
    id: 20,
    title: "某热播剧男女主演被传因戏生情，片场互动暧昧引猜测",
    slug: "reboju-nannvzhu-yinxishengqing",
    excerpt: "热播剧男女主演被剧组工作人员爆料在拍摄期间互动暧昧，疑似因戏生情。两人在社交媒体上的互动也被网友扒出诸多疑点。",
    content: `<p>目前正在热播的某都市情感剧收视火爆，而戏外男女主演的绯闻也同样引人关注。据剧组工作人员匿名爆料，两位主演在拍摄期间关系十分亲密，远超普通同事的范畴。</p>
<p>"他们在片场经常腻在一起，休息的时候也形影不离，"一位自称是剧组场务的人士在网上爆料，"有一次收工后两个人还一起去了附近的餐厅，就他们两个人。"</p>
<p>网友们随后开始仔细研究两人在社交媒体上的互动，发现了很多可疑的细节。比如男方频繁给女方的每一条动态点赞，女方晒出的照片中多次出现疑似男方的手或物品。</p>
<p>不过也有理性的声音指出，这些"证据"可能只是过度解读。"演员在拍戏期间培养感情是正常的，有助于呈现更好的银幕效果，"一位资深娱乐记者分析道。</p>`,
    category: "dianshiju",
    author: "八卦早知道",
    date: "2026-07-26",
    time: "21:00",
    views: 145678,
    image: "https://readdy.ai/api/search-image?query=A%20film%20set%20of%20a%20modern%20romance%20drama%2C%20two%20actors%20sitting%20close%20together%20between%20takes%2C%20warm%20lighting%2C%20intimate%20atmosphere%2C%20professional%20production%20environment%2C%20behind%20the%20scenes%20photography&width=800&height=450&seq=article-20&orientation=landscape",
    tags: ["热播剧", "因戏生情", "绯闻", "主演"],
    featured: false,
    hot: false,
  },
];

export const aboutData = {
  brandName: "51黑料吃瓜网",
  slogan: "吃瓜第一线，黑料天天见",
  introduction: "51黑料吃瓜网成立于2020年，是国内领先的娱乐资讯聚合平台。我们致力于为网友提供最新、最全、最热的吃瓜爆料内容，覆盖娱乐圈、网红圈、社会热点等多个领域。",
  history: "从最初的个人博客起步，51黑料凭借敏锐的嗅觉和快速的反应，逐渐发展成为拥有数百万日活用户的头部吃瓜平台。我们的编辑团队7×24小时不间断追踪热点，确保用户能在第一时间获取最新资讯。",
  mission: "我们的使命是让每一个吃瓜群众都能享受到最原汁原味的八卦体验。我们坚持真实、客观、及时的报道原则，不做虚假新闻，不传播谣言，为用户提供可信赖的吃瓜内容。",
  values: [
    { title: "真实可靠", description: "严格审核信息来源，确保每一条爆料的真实性" },
    { title: "快速及时", description: "7×24小时追踪热点，第一时间推送最新内容" },
    { title: "全面覆盖", description: "从娱乐圈到社会热点，全方位满足吃瓜需求" },
    { title: "用户至上", description: "不断优化用户体验，让吃瓜变得更简单有趣" },
  ],
  stats: [
    { label: "日均活跃用户", value: "300万+" },
    { label: "累计文章数", value: "50,000+" },
    { label: "合作媒体", value: "200+" },
    { label: "用户好评率", value: "98.5%" },
  ],
  contact: {
    email: "contact@51heiliao.com",
    wechat: "51heiliao_official",
    weibo: "@51黑料吃瓜网",
    address: "北京市朝阳区建国路88号SOHO现代城A座",
    phone: "400-888-5151",
  },
};